module.exports = __webpack_public_path__ + "assets/img/item2-info.86008ff8.png";